import { render, staticRenderFns } from "./NoTripContent.vue?vue&type=template&id=4e71899b"
import script from "./NoTripContent.vue?vue&type=script&lang=ts"
export * from "./NoTripContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports